import {Inventory} from '@mui/icons-material'
import i18n from 'i18next';

const getPackages = () => ({
  id: 'package',
  type: 'group',
  children: [
    {
      id: 'package',
      title: i18n.t('sidemenu.aiPackages'),
      type: 'item',
      url: '/package',
      icon: Inventory,
      breadcrumbs: false,
    },
  ]
});

export default getPackages;